module.exports = __webpack_public_path__ + "static/img/icon_slotmachine.05e623a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_slotmachine.png
// module id = 2afb
// module chunks = 1